let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bBCXO")).then(() => parcelRequire('34kR8'));